import type { ChangeWheelsView, EquipmentChange } from "@slfinrtl/ui-bff-routes"
import { useCallback } from "react"
import type {
	ChangeCustomWheelsFormProps,
	ChangeCustomWheelsProps,
	ChangeSelectedWheelsForm,
	ChangeSelectedWheelsProps,
} from "src/hooks"
import { customWheelsOptionCode, useChangeCustomWheelsProps, useChangeSelectedWheelsProps } from "src/hooks"
import type { FormWithProps } from "src/types/FormWithProps"
import { useChangeCustomWheelsForm } from "../changeWheels/useChangeCustomWheelsForm"
import { useChangeSelectedWheelsForm } from "../changeWheels/useChangeSelectedWheelsForm"

interface UseChangeWheelsProps {
	view: ChangeWheelsView
}

export interface UseChangeWheelsReturn {
	custom: FormWithProps<ChangeCustomWheelsFormProps, ChangeCustomWheelsProps> | undefined
	getChange: () => Pick<EquipmentChange, "setWheels">
	selected: FormWithProps<ChangeSelectedWheelsForm, ChangeSelectedWheelsProps>
}

export const useChangeWheels = ({ view }: UseChangeWheelsProps): UseChangeWheelsReturn => {
	const changeSelectedWheelsForm = useChangeSelectedWheelsForm({
		view: view.selected,
	})
	const changeSelectedWheelsProps = useChangeSelectedWheelsProps({
		view: view.selected,
	})
	const changeCustomWheelsForm = useChangeCustomWheelsForm({
		view: view.custom,
	})
	const changeCustomWheelsProps = useChangeCustomWheelsProps({
		view: view.custom,
	})

	const optionCode = changeSelectedWheelsForm.watch("optionCode")
	const isEditingCustomWheel = optionCode === customWheelsOptionCode
	const getValues = useCallback(() => {
		if (isEditingCustomWheel) {
			return { setWheels: changeCustomWheelsForm.getValues() }
		}
		return optionCode !== view.selected.option.optionCode ? { setWheels: { optionCode } } : { setWheels: undefined }
	}, [view.selected.option.optionCode, isEditingCustomWheel, optionCode, changeCustomWheelsForm])

	return {
		custom: isEditingCustomWheel ? { form: changeCustomWheelsForm, props: changeCustomWheelsProps } : undefined,
		getChange: getValues,
		selected: {
			form: changeSelectedWheelsForm,
			props: changeSelectedWheelsProps,
		},
	}
}
